import apiClient from '../client'
import type { MiningRightMapItemResponse } from '../models/response/miningRight'

const BASE_PATH = '/mining-rights'

export const miningRightsService = {
  async getMap(): Promise<MiningRightMapItemResponse[]> {
    return apiClient.get<MiningRightMapItemResponse[]>(`${BASE_PATH}/map`)
  },
}
